{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-22T21:34:10.795Z","source":"place-details"}